<template>
  <div>
    <div v-if="is_super_admin">
      <div>
        <el-carousel :interval="4000" type="card" height="328px">
          <el-carousel-item v-for="item in l_banner_data" :key="item.id">
            <div style="text-align:center;padding: 10px 16px;">
              <img :src="item.icon_url" style="width:100%;height:100%;"/>
            </div>
            
          </el-carousel-item>
          
        </el-carousel>
      </div>

      <el-divider> <i class="el-icon-more"></i> 首页Banner浏览 <i class="el-icon-more"></i></el-divider>

      <div style="padding: 12px 16px;">
        <el-button plain type="primary" @click="on_add_banner" size="small" icon="el-icon-plus">新增Banner</el-button>
      </div>

      <div>

        <el-table
          :data="l_banner_data"
          border
          
          style="width: 100%">

          <el-table-column
            label="广告标题"
            align="center"
            prop="ad_title"
          >
          </el-table-column>

          <el-table-column
            label="广告说明"
            align="center"
            prop="ad_info"
          >
          </el-table-column>

          <el-table-column
            label="Banner图片"
            align="center"
            prop="icon_url"
          >
            <template slot-scope="scope"> 
              <el-popover placement="top-start" title="图片链接" trigger="hover" >
                <img  alt="" :src="scope.row.icon_url" style="width:500px;height:500px;">
                <img  slot="reference" :src="scope.row.icon_url" style="width:200px;height:100px;">
              </el-popover>
              
            </template>
          </el-table-column>

          <el-table-column
            label="跳转链接"
            align="center"
            prop="redirect_url"
          >
          </el-table-column>

          <el-table-column
            align="center"
            label="操作"
            >
            <template slot-scope="scope">
              <el-button plain round icon="el-icon-edit" type="success" size="small" @click="on_edit_job(scope.$index, scope.row)">编辑</el-button>
              <el-button round icon="el-icon-delete" type="danger" size="small" @click="on_delete_job(scope.row)">删除</el-button>
            </template>
          </el-table-column>

        </el-table> 


      </div>

      <el-dialog :visible.sync="b_show_dialog" :fullscreen="b_show_fullscreen" :before-close="this.$dialog_close" :show-close="false" style="padding: 12px 16px;">
          
          <div slot="title" class="dialog-title">
              <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ s_dialog_name }}</span>
              <el-button icon="el-icon-close" class='dialog-title-button' @click="b_show_dialog = false"></el-button>
              <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_fullscreen = !b_show_fullscreen"></el-button>
          </div>
          <el-form :model="d_banner_form" ref="d_banner_form" label-width="100px" @class="demo-d_banner_form" :rules="d_banner_form_rules">
              <el-form-item label="广告标题" prop="ad_title">
                  <el-input v-model="d_banner_form.ad_title" placeholder="请输入广告标题"></el-input>
              </el-form-item>
              <el-form-item label="广告说明" prop="ad_info">
                  <el-input v-model="d_banner_form.ad_info" placeholder="请输入广告说明"></el-input>
              </el-form-item>

              <el-form-item label="跳转链接" prop="redirect_url">
                
                  <el-input v-model="d_banner_form.redirect_url" placeholder="请输入跳转链接"></el-input>
                  <el-alert
                  title="跳转链接为空时,则不进行跳转,可配置其他小程序跳转链接或H5链接"
                  close-text="知道了"
                  show-icon
                  type="warning">
                </el-alert>
              </el-form-item>

              <el-form-item label="banner图片">
                <el-upload
                  :disabled="b_disabled"
                  action=""
                  list-type="picture-card"
                  :limit=1
                  :file-list="l_banner_img_list"
                  :http-request="upload_banner_img"
                  :before-remove="remove_banner_img">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>

              <el-form-item class="sssss">
                <el-button type="primary" @click="save_banner" :disabled="b_disabled">{{ s_btn_name }}</el-button>
                <el-button @click="cancel_func">取消</el-button>
              </el-form-item>

          </el-form>
      
      </el-dialog>
    </div>
    
    <div v-else>
      <div style="text-align: center;">
        <div style="margin-top: 0px;">
          <img src="../assets/permission_denied.png">
          <div style="margin-top: 20px;">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  data() {
    return {
      l_banner_data: [
        {
          id: 1,
          'ad_title': '广告标题1',
          'ad_type': '广告类型1',
          'icon_url': 'https://light-house-1307928595.cos.ap-shanghai.myqcloud.com/shop_img/a1be8305-bad8-11ec-ab69-d8bbc165db7c.jpeg',
          'redirect_url': 'http://www.baidu.com',
        },
        {
          id:2,
          'ad_title': '广告标题2',
          'ad_type': '广告类型2',
          'icon_url': 'https://light-house-1307928595.cos.ap-shanghai.myqcloud.com/shop_img/a1be8305-bad8-11ec-ab69-d8bbc165db7c.jpeg',
          'redirect_url': 'http://www.baidu.com',
        },
        {
          id:3,
          'ad_title': '广告标题2',
          'ad_type': '广告类型2',
          'icon_url': 'https://light-house-1307928595.cos.ap-shanghai.myqcloud.com/shop_img/a1be8305-bad8-11ec-ab69-d8bbc165db7c.jpeg',
          'redirect_url': 'http://www.baidu.com',
        },
        {
          id:4,
          'ad_title': '广告标题2',
          'ad_type': '广告类型2',
          'icon_url': 'https://light-house-1307928595.cos.ap-shanghai.myqcloud.com/shop_img/a1be8305-bad8-11ec-ab69-d8bbc165db7c.jpeg',
          'redirect_url': 'http://www.baidu.com',
        },
        {
          id:5,
          'ad_title': '广告标题2',
          'ad_type': '广告类型2',
          'icon_url': 'https://light-house-1307928595.cos.ap-shanghai.myqcloud.com/shop_img/a1be8305-bad8-11ec-ab69-d8bbc165db7c.jpeg',
          'redirect_url': 'http://www.baidu.com',
        },
      ],
      is_super_admin: false,
      b_disabled: false,
      s_dialog_name: '',
      b_show_dialog: false,
      i_dialog_type: 1,
      b_show_fullscreen: false,
      d_banner_form: {},
      l_banner_img_list: [],
      s_btn_name: '',
      d_banner_form_rules: {
        ad_title: [
          { required: true, message: '请输入广告标题', trigger: 'blur' },
        ],
        ad_type: [
          { required: true, message: '请输入广告类型', trigger: 'blur' },
        ],
        
        
      },
      
    }
  },

  mounted() {
    // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
    let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
    if (isSuperAdmin == "false") {
      this.is_super_admin = false
      return
    } else {
      this.is_super_admin = true
    }
    this.refresh_form_data()
  },

  methods: {
    // 刷新表单数据
    async refresh_form_data() {
      let url = '/api/banner_ad/'
      let res = await this.$axios.get(url)
      this.l_banner_data = res.data
      console.log(this.l_banner_data)
    },

    // 新增广告
    on_add_banner() {
      this.s_dialog_name = '新增广告';
      this.b_show_dialog = true;
      this.d_banner_form = {};
      this.l_banner_img_list = [];
      this.s_btn_name = '新增';
      this.i_dialog_type = 1;
    },

    on_edit_job(index, row) {
      this.l_banner_img_list = [];
      this.s_dialog_name = '编辑广告';
      this.b_show_dialog = true;
      this.l_banner_img_list = [{url: row.icon_url}];
      this.d_banner_form = JSON.parse(JSON.stringify(row));
      this.i_dialog_type = 2;
      this.s_btn_name = '保存';
    },


    // 上传图片
    async upload_banner_img(option){
      this.b_disabled = true;
      const res = await this.upload_common(option)
      console.log(res)
      this.d_banner_form.icon_url = res.data.s_url
      this.b_disabled = false;
      console.log(this.d_banner_form)
    },

    // 删除图片
    async remove_banner_img(file, fileList) {
      console.log(file, fileList);
      let s_remove_url = this.d_banner_form.icon_url
      await this.remove_common(s_remove_url)
      this.d_banner_form.icon_url = ''
    },

    // 取消
    cancel_func() {
      this.b_show_dialog = false;
      this.d_banner_form = {};
      this.l_banner_img_list = [];
      this.b_disabled = false;
    },

    // 保存广告
    async save_banner() {
      
      this.b_disabled = true;
      this.s_btn_name = '保存中...';
      // 判断是否有跳转链接 如果没有跳转链接 则ad_type=1, 如果有跳转链接 则ad_type=2
      if(this.d_banner_form.redirect_url == '') {
        this.d_banner_form.ad_type = 1;
      }else{
        this.d_banner_form.ad_type = 2;
      }
      console.log(this.d_banner_form)

      if (this.i_dialog_type === 1){
        const res = await this.$axios.post('/api/banner_ad/', this.d_banner_form);
        this.request_waring(res);
      }else{
        const res = await this.$axios.put('/api/banner_ad/' + this.d_banner_form.ad_id + '/', this.d_banner_form);
        this.request_waring(res);
      }
      
      
      
    },

    // 请求警告
    request_waring(res){
      if (res.status === 201 || res.status === 200){
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.b_show_dialog = false
        // 重置表单
        this.d_banner_form = {};
        this.l_banner_img_list = [];
        this.b_disabled = false;
        // this.s_btn_name = '保存';
        this.refresh_form_data()
      } else {
        this.$message({
          message: '保存失败',
          type: 'error'
        })
      }
    },
  
    on_delete_job(row) {
      var _this = this
      console.log(row)
        this.$confirm('此操作将永久删除该岗位', '删除岗位警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          _this.$axios.delete('/api/banner_ad/' + row.ad_id + '/').then(
            function(res){
              _this.$message({
                type: 'success',
                message: '删除成功!'
              });
              _this.refresh_form_data()
            }
          )
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },


    // 上传文件通用接口
    upload_common(option){
      
      let p_file = option.file
      let l_file_type = p_file.type
      let b_is_image = l_file_type.indexOf("image") != -1

      // 是否图片
      if (!b_is_image) {
        this.$message.error("只能上传图片格式png、jpg");
        return
      }

      // form 表单
      let d_form_data = new FormData()

      d_form_data.append("file", p_file)
      d_form_data.append('folder', "banner")
      let url= '/api/upload_file/'

      let res = this.$axios.post(
          url, d_form_data, {headers: {"content-type": "multipart/form-data"}}
      )
      console.log(res)
      console.log(res.data)
      return res
    },

    // 删除文件通用接口
    remove_common(s_remove_url){
      let url = "/api/remove_file/"
      let d_data = {'s_url': s_remove_url}
      let res = this.$axios.post(url, d_data)
      console.log(res)
      return res
    },


  }
    
  

  
}
</script>

<style>
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>
